"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/styles");

var _gift = require("../../constants/gift.contstants");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    status: {
      color: '#000',
      fontWeight: 'bold'
    }
  };
});

var GiftStatus = function GiftStatus(_ref) {
  var status = _ref.status,
      props = (0, _objectWithoutProperties2.default)(_ref, ["status"]);
  var classes = useStyles({
    status
  });
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: classes.status
  }, props), _gift.GIFT_STATUSES[status]);
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftStatus);

exports.default = _default;